(function(angular){
	'use strict';
	
	angular
		.module('campaignLandingModule', [
			'affixRevealModule',
			'campaignCtaModule',
			'countUpModule',
			'coreModule',
			'waitlistModule'
		]);

})(window.angular);